export default {
    MolegameTitle: "打地鼠-遊戲設定",
    gameTitle: "打地鼠遊戲",
    topicLabel: "主題",
    correctItems: "答對題目",
    correctItemsPlaceholder: "輸入正確詞彙，用逗號(,)分隔，按下Enter新增項目",   
    errorItems: "答錯題目",
    errorItemsPlaceholder: "輸入錯誤詞彙，用逗號(,)分隔，按下Enter新增項目",
    gameDuration: "遊戲時長",
    moleSpeed: "地鼠停留時間",
    speedSlow: "長時間 (2.5秒)",
    speedMedium: "中等 (2秒)",
    speedFast: "短時間 (1.5秒)",
    speedVeryFast: "極短 (1秒)",
    second: "秒",
    saveSettings: "儲存設置",
    startGame: "開始遊戲",
    pauseGame: "暫停遊戲",
    resumeGame: "繼續遊戲",
    gameOver: "遊戲結束",
    leftSide: "左方",
    rightSide: "右方",
    leftWins: "左方獲勝！",
    rightWins: "右方獲勝！",
    tie: "平局！",
    playAgain: "再玩一次",
    wordExists: "詞彙已存在，無須重複加入",
    maxVocabulary: "正確詞彙已達最大值，請刪減詞彙再加入",
    maxErrorVocabulary: "錯誤詞彙已達最大值，請刪減詞彙再加入",
    topic: "主題",
    inputTopic: "請輸入主題",
    backgroundSetting: "背景設定",
    ocean: "海洋",
    desert: "沙漠",
    forest: "森林",
    
    // 遊戲結束畫面新增字串
    win: "勝利",
    items: "個",
    wrongItems: "答對題目",
    maxCombo: "最高連擊",
    showAnswers: "A",
    gamePaused: "活動暫停",
    referenceAnswers: "參考答案",
    clearData: "清空設定",
    sendSuccess: "遊戲資料已成功推送！",
    sendCooldown: "已按送出，請等候1分鐘才可再操作",
    configLoadSuccess: "成功載入遊戲配置",
    configLoadFailed: "載入失敗（使用範例配置）",
}
